export default "__VITE_ASSET__CFxZtvGm__"